import React, { useState } from "react";
import Navigation from "../components/Navigation";
import NavigationToggle from "../components/NavigationToggle ";
import { Container, Row, Col } from "react-bootstrap";
import Vessel from "../components/File/Vessel";
import Voyage from "../components/File/Voyage";
import SalesPerson from "../components/File/SalesPerson";
import Country from "../components/File/Country";
import Ports from "../components/File/Ports";
import Currency from "../components/File/Currency";
import Incoterms from "../components/File/Incoterms";
import Containers from "../components/File/Container";
import Tax from "../components/File/Tax";
import Rates from "../components/File/Rates";
import Customer from "../components/File/Customer";
import Supplier from "../components/File/Supplier";
import TransactionsClass from "../components/File/TransactionClass";
import TransactionsType from "../components/File/TransactionType";
import PaymentMode from "../components/File/PaymentMode";

import BookingCosting from "../components/Transactions/BookingCosting";

const Dashboard = () => {
  const [activeComponent, setActiveComponent] = useState("Dashbord");
  const [showNavigation, setShowNavigation] = useState(true);

  const toggleNavigation = () => {
    setShowNavigation(!showNavigation);
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "vessel":
        return <Vessel />;
      case "voyage":
        return <Voyage />;
      case "salesperson":
        return <SalesPerson />;
      case "country":
        return <Country />;
      case "port":
        return <Ports />;
      case "currency":
        return <Currency />;
      case "incoterms":
        return <Incoterms />;
      case "container":
        return <Containers />;
      case "tax":
        return <Tax />;
      case "rates":
        return <Rates />;
      case "customer":
        return <Customer />;
      case "supplier":
        return <Supplier />;
      case "transactionsclass":
        return <TransactionsClass />;
      case "transactionstype":
        return <TransactionsType />;
      case "paymentmode":
        return <PaymentMode />;
      case "bookingcosting":
        return <BookingCosting />;
      default:
    }
  };
  return (
    <Container fluid>
      <Row className={`main-content ${showNavigation ? "sidebar-open" : ""}`}>
        <Col
          md={2}
          className={`bg-light sidebar  nav-sec ${
            showNavigation ? "show" : "hide"
          }`}
        >
          <Navigation setActiveComponent={setActiveComponent} />
        </Col>
        <Col
          className={`w-auto content ${
            showNavigation ? "" : "main-content-right-side"
          }`}
        >
          <NavigationToggle
            showNavigation={showNavigation}
            toggleNavigation={toggleNavigation}
          />
          {renderComponent()}
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
